/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages


    'common': {
      init: function() {
        var ua = navigator.userAgent;
        // JavaScript to be fired on all pages
        function header_fixed(){
          var header = $('#is-header');

          header_offset = $(window).height()/2; //windowの半分
          header_height = header.outerHeight();// ヘッダーの高さ

          $(window).scroll(function () {
            if($(window).scrollTop() > header_offset - header_height) {
              header.stop(true).animate({'padding-top':'0'},150);
              header.addClass('header_fixed');
            }else {
              header.stop(true).animate({'padding-top':'75px'},150);
              header.removeClass('header_fixed');
            }
          });
        }
        if (ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {

        } else{
          header_fixed();
        }


        function mobile_header() {
          var $icon = jQuery(".st-Nav_Micon");
          var $nav = jQuery(".st-Nav");
          $icon.on('click',function(){
            //open用のクラスがあるかどうか判定
            $nav.slideToggle();
            console.log($nav);


          });




        }
        mobile_header();


        // Instantiate MixItUp:
        jQuery('#WorksSort').mixItUp();

        // Instantiate MixItUp:
        jQuery('#SingleWorksSort').mixItUp();


        // home fade Images
        function fadeToNextImage ( firstImage ) {
          jQuery("#images li.on").each(function(index) {
            if (!firstImage) {
              jQuery(this).removeClass("on").fadeIn(1500).delay(800).fadeOut(1, function(){
                var next = jQuery(this).next();
                if (next.length > 0) {
                  jQuery(this).next().addClass("on");
                } else {
                  jQuery("#images li:first-child").addClass("on");
                }
                fadeToNextImage(false);
              });
            } else {
              $(this).delay(1500).fadeOut(1, function(){
                $(this).removeClass("on").next().addClass("on");
                fadeToNextImage(false);
              });
            }
          });
        }
        setTimeout(fadeToNextImage(true), 1500);


        //WINDOW スクロールでフェードアウト
        function scroll_fadeOut(){
          jQuery(window).scroll(function(){//スクロール検知したら
            if(jQuery(window).scrollTop()>50 && jQuery('h1').css('opacity')!=0){
              jQuery('.st-Nav_Logo').animate({'opacity':1},1000);

              if (ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
                jQuery('h1').animate({
                  'top': '50%',
                  'opacity': 0
                }, 1500, function () {
                  jQuery(this).css({
                    'top': '10%',
                    'z-index': 1
                  }).stop(true, true);
                });


              } else {


                jQuery('h1').animate({
                  'top': '50%',
                  'opacity': 0
                }, 1500, function () {
                  jQuery(this).css({
                    'top': '35%',
                    'z-index': 1
                  }).stop(true, true);
                });
              }


            }else if(jQuery(window).scrollTop()<50 && $('h1').css('opacity')==0){
              jQuery('h1').css('z-index',10);
              jQuery('.st-Nav_Logo').stop(true).animate({'opacity':0},1000);
              jQuery('h1').stop(true).animate({
                'opacity':1
              },1500,function(){
                jQuery(this).removeClass('done');
              });
            }else if (jQuery(window).scrollTop()>jQuery(document).height()/2 && jQuery('#worksButton').css('display')=='block'){
              jQuery('#worksButton').stop(true).fadeOut();
            }else if (jQuery(window).scrollTop()<jQuery(document).height()/2 && jQuery('#worksButton').css('display')=='none'){
              jQuery('#worksButton').stop(true).fadeIn();
            }
          });

        }
        scroll_fadeOut();







//ハンバーガーメニューのアニメーション
        var $window = $(window),
          $wrapper = $(".photo_ct-mobile"),
          $nav = $("#js-nav-mobile"),
          $menuButton = $(".menu-button"),
          $jsCover = $("#js-nav-cover"),
          $navMenu = $("#js-nav-menu"),
          navHeight = $navMenu.height(),
          //アニメーションのスピード
          SPEED = 300,
          //bodyの高さ
          bodyHeight = $wrapper.height(),
          //ヘッダーの高さ
          HEADER_HEIGHT = 48;

        //リサイズ時でもwindowとwrapperのサイズを取得
        $window.on( 'load orientationchange', function(){
          windowHeight = $window.height();
        });

        function openAction(){
          $nav.addClass('is-open');
          $navMenu.animate({right:0},SPEED);
          //windodwの高さがナビゲーションより高さが狭いとき
          if(navHeight > windowHeight){
            //wrapperの高さnavの高さにする
            $wrapper.css({overflow:'hidden'}).height(navHeight + HEADER_HEIGHT);
            //高さをつけてオーバーレイを表示

            $jsCover.show();
            $jsCover.height(navHeight + HEADER_HEIGHT).stop().animate({opacity:0.8},SPEED);
          } else {
            //wrapperの高さwindowの高さと同じにする
            $wrapper.css({overflow:'hidden'}).height(windowHeight);
            //高さをつけてオーバーレイを表示
            $jsCover.show();
            $jsCover.height(windowHeight).stop().animate({opacity:0.8},SPEED);
          }
        }
        function closeAction(){
          //クラスを外す
          $nav.removeClass('is-open');
          $navMenu.animate({right:-240},SPEED);

          //wrapperの高さを元にもどしてスクロールできるようにする。
          $wrapper.css({overflow:'visible'}).height(bodyHeight);

          //オーバーレイが消える
          $jsCover.hide();
          $jsCover.stop().animate({opacity:0},SPEED);
        }
        $menuButton.on('click',function(){
          //open用のクラスがあるかどうか判定
          if($nav.hasClass('is-open')){
            //閉じるときの動き
            closeAction();
          } else {
            //開くときの動き
            openAction();
          }
        });





      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
        $('a.category_link').click(function(e) {
          e.preventDefault();
          var place = $(this).data("place");
          var target = $('html, body');
          console.log(place);
          if (place === "works"){
            target.animate({scrollTop: $('#WorksSort').offset().top - 30},500);}
          else if(place === "contact"){
            target.animate({scrollTop: $('#contact').offset().top - 30},500);}
          else if(place === "about"){
            target.animate({scrollTop: $('#about').offset().top - 30},500);}
          else if(place === "news"){
            target.animate({scrollTop: $('#news').offset().top - 30},500);}
          else if(place === "top"){
            target.animate({scrollTop: $('#top').offset().top},500);}

        });


      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.





